import { useField } from "formik";

import { Box, Container, Typography } from "@mui/material";

import FormLabel from "@components/Forms/FormLabel/Index";

import { AttachmentType } from "@interfaces/campaign.type";

import FormField from "@pages/CreateCampaign/components/FormField";

import AttachmentsManager from "../components/AttachmentsManager";

interface ICreateCampaignSetupProperties {
  deleteAttachment: (attachmentId: number, attachmentName: string) => Promise<void>;
  uploadAttachment: (file: File[]) => Promise<void>;
}

export default function EditNameAndDescription({ deleteAttachment, uploadAttachment }: ICreateCampaignSetupProperties) {
  const [attachmentsField] = useField<AttachmentType[]>("attachments");
  const [name] = useField("name");
  const [technologySummary] = useField("technologySummary");

  return (
    <Container
      maxWidth="md"
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        height: "100%",
        overflow: "auto",
        width: "100%",
      }}
    >
      <FormField
        inputLabel="Campaign Name"
        name="name"
        stepLabel="Name your campaign:"
        stepNumber={1}
        tooltip="Give your campaign a name to help you identify it later."
      />
      <FormField
        inputLabel="Technology Summary"
        isMultiline
        name="technologySummary"
        rows={4}
        stepLabel="Describe your technology:"
        stepNumber={2}
        tooltip="Include a technology summary to provide a better understanding of your technology to the recipient."
      />
      <Box>
        <FormLabel
          hasValue={attachmentsField.value && attachmentsField.value.length > 0}
          isOptional
          label="Attach file(s) to your email:"
          name="attachments"
          stepNumber={3}
          tooltip="Attach PDFs, presentations, or any other file that you think would be helpful for the recipient to understand your technology."
        />
        <Typography>The combined file size limit is 3MB. You can upload multiple files at once.</Typography>
        <AttachmentsManager
          attachments={attachmentsField.value}
          deleteAttachment={deleteAttachment}
          isDisabled={!name.value || !technologySummary.value}
          uploadAttachment={uploadAttachment}
        />
      </Box>
    </Container>
  );
}
